// @ts-check
import React, { forwardRef } from 'react';

/** @typedef {{
  id?: string;
  name?: string;
  indicateOptional?: boolean;
  label: React.ReactNode;
  labelId?: string;
  className?: string;
  labelClassName?: string;
  htmlFor?: string;
} & React.HTMLAttributes<HTMLDivElement>} FieldStructureProps */

/** @type { React.FC<FieldStructureProps> } */
export const VerticalField = forwardRef((props, ref) => {
  const {
    label,
    indicateOptional = false,
    children,
    className = '',
    labelId,
    htmlFor,
    ...rest
  } = props;
  return (
    <div className={`text-left ${className}`} ref={ref} {...rest}>
      <label
        id={labelId}
        htmlFor={htmlFor}
        className="mb-1 font-bold text-left text-gray-700"
        style={{ display: 'block' }}
      >
        {label}
        {indicateOptional && (
          <span className="ml-2 text-xs font-normal text-gray-500">
            Optional
          </span>
        )}
      </label>
      {children}
    </div>
  );
});

/** @type { React.FC<FieldStructureProps> } */
export const HorizontalField = forwardRef((props, ref) => {
  const {
    label,
    indicateOptional = false,
    children,
    className = '',
    labelId,
    htmlFor,
    ...rest
  } = props;

  return (
    <div className={`md:flex md:items-start ${className}`} ref={ref} {...rest}>
      <div className="md:w-1/3">
        <label
          id={labelId}
          htmlFor={htmlFor}
          className="md:py-2 md:text-right md:mb-0 block py-1 pr-4 mb-1 font-bold text-gray-700"
        >
          {label}
          {indicateOptional && (
            <span className="block ml-2 text-xs font-normal text-gray-500">
              Optional
            </span>
          )}
        </label>
      </div>
      <div className="md:w-2/3 md:py-1">{children}</div>
    </div>
  );
});
